export function getOfferComparisonSelectionPrice(selection: App.OfferComparisonSelection, canRedeemLuxPlus: boolean) {
  if (!selection.priceTotals) return 0
  const { price, memberPrice } = selection.priceTotals
  if (!canRedeemLuxPlus) return price ?? 0
  return memberPrice > 0 ? memberPrice : price ?? 0
}
